import Vue from 'vue';
import LayoutMainSidebar from '@/components/layout/main-sidebar';
import Flex, { FlexItem } from '@/components/flex';
import WhiteSpace from '@/components/white-space';
import WingBlank from '@/components/wing-blank';
import Card from '@/components/card';
import Pagination from '@/components/pagination';
import ButtonConfirm from '@/components/button-confirm';
import Panel from '@/components/panel';
import Timeline from '@/components/timeline';
import DataEmptySimple from '@/components/data-empty/simple';
import FormWrap from '@/components/form-wrap';
import DataShow from '@/components/data-show';
import InputNumber from '@/components/input-number';
import AppPage from '@/layout/components/app-page';
import Drawer from '@/components/drawer'; // 抽屉
import DatePicker from '@/components/date-picker';
import ImageItems from '@/components/image-items'; // 图片展示
import BatchSearch from '@/components/batch-search'; // 批量搜索
import Status from '@/components/status'; // 状态
import IconStatus from '@/components/icon-status'; // 状态图标
import JrSearch from '@/components/jr-search'; // 搜索组件
import SearchDatePicker from '@/components/jr-search/components/search-date-picker'; // 搜索组件-开始结束时间
import SearchInputSelect from '@/components/jr-search/components/search-input-select'; // 搜索组件-输入框选择
import ExportButton from '@/components/export-button';
import Pdf from 'vue-pdf';
import JrOperateDialog from '@/components/operate-btns/operate-dialog';
import JrTable from '@/components/jr-table';
import JrCol from '@/components/jr-col';
import JrRow from '@/components/jr-row';
import JrTooltip from '@/components/jr-tooltip';
import JrSelect from '@/components/jr-select';
import JrLabel from '@/components/jr-label';
import JrSearch2 from '@/components/jr/jr-search2/search'; // 搜索组件2
import JrColumnsConfig from '@/components/jr/jr-columns-config'; // table配置
import pageEncryptIcon from '@/components/pageComponents/page-encrypt-icon';
import JrFileUpload from '@/components/jr/jr-upload/file-upload';
import pageSourceSelect from '@/components/pageComponents/pageSourceSelect';
import JrCard from '@/components/baseComponents/jr-card';
import JrPreviewImage from '@/components/jr-preview/preview-image';
import pageExportButton from '@/components/pageComponents/page-export-button';
import pageSelectGroups from '@/components/pageComponents/pageSelectGroups';
import pageCascaderSelect from '@/components/pageComponents/pageCascader';

// register global components
Vue.component('layout-main-sidebar', LayoutMainSidebar);
Vue.component('card', Card);
Vue.component('pagination', Pagination);
Vue.component('flex', Flex);
Vue.component('flex-item', FlexItem);
Vue.component('white-space', WhiteSpace);
Vue.component('wing-blank', WingBlank);
Vue.component('button-confirm', ButtonConfirm);
Vue.component('panel', Panel);
Vue.component('timeline', Timeline);
Vue.component('data-empty-simple', DataEmptySimple);
Vue.component('form-wrap', FormWrap);
Vue.component('data-show', DataShow);
Vue.component('input-number', InputNumber);
Vue.component('app-page', AppPage);
Vue.component('finance-drawer', Drawer);
Vue.component('date-picker', DatePicker);
Vue.component('image-items', ImageItems);
Vue.component('batch-search', BatchSearch);
Vue.component('status', Status);
Vue.component('icon-status', IconStatus);
Vue.component('jr-search', JrSearch);
Vue.component('search-date-picker', SearchDatePicker);
Vue.component('search-input-select', SearchInputSelect);
Vue.component('Pdf', Pdf);
Vue.component('export-button', ExportButton);
Vue.component('operate-dialog', JrOperateDialog);
// 基础公共组件
Vue.component('jr-table', JrTable);
Vue.component('jr-col', JrCol);
Vue.component('jr-row', JrRow);
Vue.component('jr-tooltip', JrTooltip);
Vue.component('jr-select', JrSelect);
Vue.component('jr-label', JrLabel);
Vue.component('jr-operate-dialog', JrOperateDialog);
Vue.component('jr-search2', JrSearch2);
Vue.component('jr-columns-config', JrColumnsConfig);
Vue.component('jr-file-upload', JrFileUpload);
Vue.component('jr-card', JrCard);
Vue.component('jr-preview-image', JrPreviewImage);

// 业务组件
Vue.component('page-encrypt-icon', pageEncryptIcon);
Vue.component('page-source-select', pageSourceSelect);
Vue.component('page-export-button', pageExportButton);
Vue.component('page-select-groups', pageSelectGroups);
Vue.component('page-select-cascader', pageCascaderSelect);
